module.exports = __webpack_public_path__ + "media/brands/alfa romeo-7b42ec26.png";